<template>
    <div @click.capture="getVariant">
        <slot></slot>
    </div>
</template>

<script>
import { getNamedParentContext } from '@/assets/js/helper/vm'
import ProductWrapper from '@/components/public/product/ProductWrapper'

export default {
  name: 'ProductVariantHandler',
  components: {
  },
  props: {
  },
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    getVariant (e) {
      // We do not want to change modified clicks.
      if (e.ctrlKey || e.keyCode === 17) {
        return
      }

      let target = e.target
      while (target !== this.$el && target.parentElement !== null && !target.hasAttribute('data-slug')) {
        target = target.parentElement
      }

      if (target?.hasAttribute('data-slug') ?? false) {
        e.preventDefault()
        const dataSlug = target.getAttribute('data-slug')
        this.$emit('isVariantChange', dataSlug)
        this.productWrapperContext.$emit('getVariant', dataSlug)
      }
    }
  },
  beforeCreate () {
    this.productWrapperContext = getNamedParentContext(ProductWrapper.name, this)
  },
  mounted () {
  },
  watch: {
  }
}
</script>

<style lang="scss">
</style>
